(() => {
  if (window.fixedProductDetailLoaded) return;
  window.fixedProductDetailLoaded = true;
  const rootUrl = window.Shopify?.routes?.root || '/';
  const words = () => JSON.parse(document.querySelector('[data-fixed-pdp-translations]')?.textContent || '{}');
  const dateKey = date => date.toISOString().slice(0, 10);
  let shippingCart = null;
  let shippingCartUnavailable = false;
  let shippingCartRequest = 0;
  function updateFreeShipping() {
    document.querySelectorAll('[data-fixed-free-shipping]').forEach(badge => {
      const root = badge.closest('.fixed-pdp');
      const quantityInput = root?.querySelector('input[name="quantity"]');
      const quantity = Number(quantityInput?.value || 1);
      const threshold = Number(badge.dataset.threshold);
      const unitPrice = Number(badge.dataset.unitPrice);
      const total = shippingCart ? shippingCart.total_price : Number(badge.dataset.cartTotal);
      const valid = !shippingCartUnavailable && (!shippingCart || shippingCart.currency === badge.dataset.currency) &&
        [quantity, threshold, unitPrice, total].every(Number.isFinite) && quantity > 0;
      badge.hidden = !valid;
      if (!valid) return;
      const label = total + unitPrice * quantity >= threshold ? badge.dataset.freeLabel : badge.dataset.fromLabel;
      const text = badge.querySelector('[data-fixed-shipping-label]');
      if (text.textContent !== label) text.textContent = label;
      const remaining = Math.max(0, threshold - total - unitPrice * quantity);
      const remainingText = badge.querySelector('[data-fixed-shipping-remaining]');
      if (remainingText) {
        remainingText.hidden = remaining === 0;
        if (remaining > 0) {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'cs', {
            style:'currency', currency:badge.dataset.currency, minimumFractionDigits:0, maximumFractionDigits:2
          }).format(remaining / 100);
          const message = badge.dataset.remainingLabel.replace('__AMOUNT__',amount);
          if (remainingText.textContent !== message) remainingText.textContent = message;
        }
      }
      if (!badge.dataset.tooltipBound) {
        badge.dataset.tooltipBound = 'true';
        badge.addEventListener('pointerenter', event => {if (event.pointerType === 'mouse') badge.open = true;});
        badge.addEventListener('pointerleave', event => {if (event.pointerType === 'mouse' && !badge.contains(document.activeElement)) badge.open = false;});
        badge.addEventListener('toggle', () => positionShippingPopover(badge));
        badge.addEventListener('keydown', event => {if(event.key === 'Escape') {badge.open = false; badge.querySelector('summary').focus();}});
      }
    });
  }
  function positionShippingPopover(badge) {
    if (!badge.open) return;
    const popover = badge.querySelector('.fixed-pdp__shipping-popover');
    popover.style.setProperty('--shipping-offset','0px');
    const rect = popover.getBoundingClientRect();
    const offset = rect.left < 12 ? 12 - rect.left : Math.min(0, innerWidth - 12 - rect.right);
    popover.style.setProperty('--shipping-offset',`${offset}px`);
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-fixed-free-shipping][open]').forEach(badge => {if (!badge.contains(event.target)) badge.open = false;});
  });
  window.addEventListener('resize', () => document.querySelectorAll('[data-fixed-free-shipping][open]').forEach(positionShippingPopover));
  async function refreshShippingCart() {
    if (!document.querySelector('[data-fixed-free-shipping]')) return;
    const request = ++shippingCartRequest;
    try {
      const response = await fetch(`${rootUrl}cart.js`, {cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (request !== shippingCartRequest) return;
      if (!Number.isFinite(cart.total_price) || !cart.currency) throw new Error('Invalid cart');
      shippingCart = cart;
      shippingCartUnavailable = false;
      updateFreeShipping();
    } catch (error) {
      if (request === shippingCartRequest) {
        shippingCartUnavailable = true;
        updateFreeShipping();
      }
    }
  }
  ['afterCartChanged', 'afterUpdateQuantity'].forEach(name => document.addEventListener(name, refreshShippingCart));
  document.addEventListener('afterQuantityUpdate', updateFreeShipping);
  ['input', 'change'].forEach(name => document.addEventListener(name, event => {
    if (event.target.matches('.fixed-pdp input[name="quantity"]')) updateFreeShipping();
  }));
  window.addEventListener('pageshow', event => {if (event.persisted) refreshShippingCart();});
  const readList = (value, fallback = []) => {
    try {const list = JSON.parse(value); return Array.isArray(list) && list.length ? list : fallback;}
    catch {return fallback;}
  };
  const nextDate = date => date.setUTCDate(date.getUTCDate() + 1);
  const isWorkingDate = (date, weekdays, holidays) => weekdays.includes(date.getUTCDay() || 7) && !holidays.includes(dateKey(date));
  function nextWorkingDate(date, weekdays, holidays) {
    let guard = 0;
    while (!isWorkingDate(date, weekdays, holidays) && guard++ < 370) nextDate(date);
    return isWorkingDate(date, weekdays, holidays) ? date : null;
  }
  function dispatchDate(now, cutoff, weekdays, holidays) {
    if (!/^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(cutoff)) return null;
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Prague',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p => [p.type,p.value]));
    const today = new Date(`${parts.year}-${parts.month}-${parts.day}T12:00:00Z`);
    const dispatch = new Date(today);
    const [hour, minute] = cutoff.split(':').map(Number);
    if (Number(parts.hour) * 60 + Number(parts.minute) >= hour * 60 + minute) nextDate(dispatch);
    return {today, dispatch:nextWorkingDate(dispatch, weekdays, holidays)};
  }
  function deliveryDate(dispatch, days, weekdays, holidays) {
    if (!Number.isInteger(days) || days < 0 || days > 60) return null;
    const delivery = new Date(dispatch);
    for (let remaining = days, guard = 0; remaining > 0; guard++) {
      if (guard > 730) return null;
      nextDate(delivery);
      if (isWorkingDate(delivery, weekdays, holidays)) remaining--;
    }
    return nextWorkingDate(delivery, weekdays, holidays);
  }
  function positionDeliveryPopover(details) {
    const popover = details.querySelector('.fixed-pdp__delivery-popover');
    if (!popover || !details.open) return;
    popover.style.setProperty('--delivery-offset','0px');
    const rect = popover.getBoundingClientRect();
    const offset = rect.right > innerWidth - 12 ? innerWidth - 12 - rect.right : Math.max(0, 12 - rect.left);
    popover.style.setProperty('--delivery-offset',`${offset}px`);
  }
  function updateDelivery(scope = document) {
    scope.querySelectorAll('[data-fixed-delivery]').forEach(container => {
      const dates = dispatchDate(new Date(), container.dataset.cutoff,
        readList(container.dataset.weekdays,[1,2,3,4,5]), readList(container.dataset.holidays));
      if (!dates?.dispatch) {container.hidden = true; return;}
      const {today, dispatch} = dates;
      const tomorrow = new Date(today); nextDate(tomorrow);
      const format = date => new Intl.DateTimeFormat(document.documentElement.lang || 'cs', {
        day:'numeric',month:'numeric', ...(date.getUTCFullYear() !== today.getUTCFullYear() ? {year:'numeric'} : {}),timeZone:'UTC'
      }).format(date);
      const label = dateKey(dispatch) === dateKey(today) ? container.dataset.todayLabel :
        dateKey(dispatch) === dateKey(tomorrow) ? container.dataset.tomorrowLabel :
        container.dataset.dateLabel.replace('__DATE__',format(dispatch));
      const dispatchLabel = container.querySelector('[data-fixed-dispatch]');
      if (dispatchLabel.textContent !== label) dispatchLabel.textContent = label;
      container.querySelectorAll('[data-transit-days]').forEach(row => {
        const delivery = deliveryDate(dispatch, Number(row.dataset.transitDays),
          readList(row.dataset.deliveryWeekdays,[1,2,3,4,5]), readList(row.dataset.deliveryHolidays));
        row.hidden = !delivery;
        if (!delivery) return;
        const time = row.querySelector('time');
        time.dateTime = dateKey(delivery);
        if (time.textContent !== format(delivery)) time.textContent = format(delivery);
      });
      container.hidden = false;
      const details = container.querySelector('details');
      if (details && !details.dataset.bound) {
        details.dataset.bound = 'true';
        details.addEventListener('pointerenter', event => {if(event.pointerType === 'mouse') details.open = true;});
        details.addEventListener('pointerleave', event => {if(event.pointerType === 'mouse' && !details.contains(document.activeElement)) details.open = false;});
        details.addEventListener('toggle', () => positionDeliveryPopover(details));
        details.addEventListener('keydown', event => {if(event.key === 'Escape') {details.open = false; details.querySelector('summary').focus();}});
      }
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-fixed-delivery] details[open]').forEach(details => {if (!details.contains(event.target)) details.open = false;});
  });
  document.addEventListener('visibilitychange', () => {if (!document.hidden) updateDelivery();});
  window.addEventListener('resize', () => document.querySelectorAll('[data-fixed-delivery] details[open]').forEach(positionDeliveryPopover));
  function scheduleDeliveryRefresh() {
    setTimeout(() => {if (!document.hidden) updateDelivery(); scheduleDeliveryRefresh();}, 60000 - Date.now() % 60000 + 20);
  }
  scheduleDeliveryRefresh();
  // Keep the app-owned button and its event handlers; the app can insert it asynchronously.
  const actionObservers = new WeakMap();
  function arrangeSecondaryActions(root) {
    const footer = root.querySelector('.fixed-pdp__meta');
    if (!footer) return;
    let actions = footer.querySelector('.fixed-pdp__secondary-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'fixed-pdp__secondary-actions';
      footer.append(actions);
    }
    const sku = footer.querySelector('.fixed-pdp__sku');
    if (sku && !sku.querySelector('[data-fixed-copy-sku]')) {
      const copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'fixed-pdp__copy-sku';
      copy.dataset.fixedCopySku = '';
      copy.setAttribute('aria-label', words().copy_label);
      copy.title = copy.getAttribute('aria-label');
      copy.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="8" y="8" width="12" height="13" rx="2"/><path d="M15 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3"/></svg>';
      sku.append(copy);
    }
    const compare = footer.querySelector('compare-add-button');
    if (compare && compare.parentElement !== actions) actions.append(compare);
    root.querySelectorAll('.gw-button-widget').forEach(button => {
      if (button.parentElement !== actions) actions.prepend(button);
      if (!button.querySelector('.fixed-pdp__watch-icon')) {
        button.insertAdjacentHTML('afterbegin', '<svg class="fixed-pdp__watch-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4"/></svg>');
      }
    });
  }
  function initialize() {
    updateFreeShipping();
    document.querySelectorAll('.fixed-pdp').forEach(root => {
      arrangeSecondaryActions(root);
      if (!actionObservers.has(root)) {
        const observer = new MutationObserver(() => arrangeSecondaryActions(root));
        observer.observe(root, {childList:true, subtree:true});
        actionObservers.set(root, observer);
      }
    });
    document.querySelectorAll('[data-fixed-premium-sections]').forEach(target => {
      target.dataset.fixedPremiumSections.split(',').forEach(key => {
        if (!/^[a-zA-Z0-9_]+$/.test(key)) return;
        const section = document.querySelector(`[id$="__${key}"]`);
        if (section && !target.contains(section) && !section.contains(target)) target.append(section);
      });
    });
    updateDelivery();
  }
  document.addEventListener('afterVariantChanged', initialize);
  document.addEventListener('fixedProductReady', initialize);
  document.addEventListener('optionValueSelectionChange', event => {
    const main = document.getElementById(`MainProduct-${event.detail.sectionId}`);
    main?.querySelectorAll('[data-fixed-coupon]').forEach(button => {button.disabled=true;});
  });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('click', async event => {
    const copyButton = event.target.closest('[data-fixed-copy-sku]');
    if (copyButton) {
      event.preventDefault();
      const sku = copyButton.closest('.fixed-pdp__sku');
      const raw = [...sku.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim();
      const code = raw.slice(raw.indexOf(':') + 1).trim();
      if (!code) return;
      const originalLabel = copyButton.getAttribute('aria-label');
      try {
        await navigator.clipboard.writeText(code);
        copyButton.dataset.copied = 'true';
        copyButton.title = words().copy_success;
        copyButton.setAttribute('aria-label', copyButton.title);
        let status = sku.querySelector('[data-copy-status]');
        if (!status) {
          status = document.createElement('span');
          status.dataset.copyStatus = '';
          status.className = 'visually-hidden';
          status.setAttribute('role', 'status');
          sku.append(status);
        }
        status.textContent = copyButton.title;
        setTimeout(() => {
          delete copyButton.dataset.copied;
          copyButton.title = originalLabel;
          copyButton.setAttribute('aria-label', originalLabel);
          status.textContent = '';
        }, 2000);
      } catch (error) {
        copyButton.title = words().copy_failed;
        copyButton.setAttribute('aria-label', copyButton.title);
      }
      return;
    }
    const reviewLink = event.target.closest('.fixed-pdp a[href="#judgeme_product_reviews"]');
    if (reviewLink) {
      const panel = document.querySelector('.tabs__tab-content:has(.jdgm-review-widget), .tabs__tab-content:has(.jdgm-rev-widg), .tabs__tab-content:has(.jdgm-widget)');
      const radio = panel && document.getElementById(`tab-item-input-${panel.dataset.suffix}`);
      if (radio) {event.preventDefault();radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
    }
    const button = event.target.closest('[data-fixed-coupon]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const product = button.closest('product-info');
    const productForm = product?.querySelector('product-form');
    const form = productForm?.querySelector('form');
    const submit = form?.querySelector('[type="submit"]');
    if (!form || !submit || submit.disabled || submit.getAttribute('aria-disabled')==='true' || !form.reportValidity()) return;
    const code = button.dataset.fixedCoupon;
    const data = new FormData(form);
    const variantId = data.get('id');
    button.disabled=true;
    submit.setAttribute('aria-disabled','true');
    productForm.handleErrorMessage();
    let added = false;
    try {
      const addResponse = await fetch(`${rootUrl}cart/add.js`,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:data});
      const add = await addResponse.json();
      if (!addResponse.ok || add.status) throw new Error(add.description || words().request_failed);
      added=true;
      const updateResponse = await fetch(`${rootUrl}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code})});
      if (!updateResponse.ok) throw new Error(words().coupon_failed);
      const cart = await updateResponse.json();
      const applied = (cart.discount_codes || []).some(d=>d.code.toLowerCase()===code.toLowerCase() && d.applicable);
      if (!applied) throw new Error(words().coupon_failed);
      document.dispatchEvent(new CustomEvent('afterCartChanged',{detail:{productVariantId:variantId,source:'fixed-product-coupon',cartData:cart}}));
      window.location.assign(`${rootUrl}cart`);
    } catch(error) {
      productForm.handleErrorMessage(added ? words().coupon_failed : error.message);
      if (added) {
        button.hidden=true;
        const link = document.createElement('a');
        link.href=`${rootUrl}cart`;
        link.textContent=words().view_cart;
        button.after(link);
      }
    } finally {
      button.disabled=false;
      submit.removeAttribute('aria-disabled');
    }
  });
  initialize();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  setInterval(() => {if(!document.hidden) initialize();},60000);
})();
